import {
  Autocomplete, Box, Button, FormControl, Grid,
  MenuItem, Select, Typography, TextField, Divider
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BuildIcon from "@mui/icons-material/Build";
import dayjs from "dayjs";
import maintenance from "../../../services/maintenance";
import maintenanceSerivice from "../../../services/maintenance";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import { Html5Qrcode } from "html5-qrcode";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// ── Styles (mirrored from ProductionEntryAdd) ─────────────────────────────────

const pageSx = {
  background: "#F4F7FB",
  minHeight: "100vh",
  padding: "20px 24px 40px",
  fontFamily: "'Inter', Arial, sans-serif",
};

const pageHeaderSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  mb: 2.5,
};

const pageTitleSx = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#000000",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const backBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#2B6CB0",
  padding: "7px 14px",
  border: "1.5px solid #2B6CB0",
  borderRadius: "7px",
  background: "#fff",
  cursor: "pointer",
  textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};

const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0",
  overflow: "hidden",
  mb: 2,
};

const sectionHeaderSx = {
  background: "#1C3A5E",
  padding: "12px 22px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const sectionHeaderTitleSx = {
  fontSize: "13px",
  fontWeight: 600,
  color: "#fff",
  letterSpacing: "0.3px",
};

const formBodySx = { padding: "20px 22px" };

const fieldLabelSx = {
  fontSize: "12px",
  fontWeight: 600,
  color: "#2063b6",
  mb: "4px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa",
    height: "36px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
  },
  "& input": {
    color: "#1A202C",
    fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};

const readonlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
    background: "#F0F4F8",
  },
};

const datePickerSx = {
  width: "100%",
  ...inputSx,
};

const formFooterSx = {
  padding: "18px 24px",
  background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "10px",
};

const saveBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#4CAF50",
  color: "#fff",
  border: "none",
  fontSize: "14px",
  fontWeight: 600,
  textTransform: "none",
  borderRadius: "8px",
  fontFamily: "'Inter', Arial, sans-serif",
  "&:hover": { background: "#028b19" },
  "&.Mui-disabled": { background: "#94a3b8", color: "#fff" },
  transition: "all 0.15s ease",
};

const cancelBtnSx = {
  display: "flex",
  alignItems: "center",
  gap: "7px",
  padding: "0 22px",
  height: "40px",
  background: "#E53E3E",
  color: "#ffffff",
  border: "none",
  "&:hover": { background: "#971f16" },
  fontSize: "14px",
  fontWeight: 600,
  borderRadius: "8px",
  textTransform: "none",
};

const menuItemSx = {
  fontSize: "13px",
  fontFamily: "'Inter', Arial, sans-serif",
};

// ─────────────────────────────────────────────────────────────────────────────

const Addmaintenance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSubmit } = useForm();
  const login_details = sessionStorage.getItem("loginUser");
  const userInfo = login_details ? JSON.parse(login_details).result.userInfo : {};
  const editData = location.state;
  const plant_id = userInfo.plant_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;

  const [data, setData] = useState({
    cylinder_no: editData?.cylinder_no || "",
    cyl_id: editData?.cyl_id || "",
    hydro_test_date: editData?.hydro_test_date ? dayjs(editData.hydro_test_date).format("DD/MM/YYYY") : dayjs().format("DD/MM/YYYY"),
    inspection_date: editData?.inspection_date ? dayjs(editData.inspection_date).format("DD/MM/YYYY") : dayjs().format("DD/MM/YYYY"),
    leakage_from_valve: editData?.leakage_from_valve || "",
    leakage_from_cyl_neck_thread: editData?.leakage_from_cyl_neck_thread || "",
    leakage_from_fusible_plug: editData?.leakage_from_fusible_plug || "",
    corrosion_bottom_ring: editData?.corrosion_bottom_ring || "",
    burn_mark: editData?.burn_mark || "",
    damaged_valve: editData?.damaged_valve || "",
    painting: editData?.painting || "",
    tag_not_readable: editData?.tag_not_readable || "",
    corrosion_pitting: editData?.corrosion_pitting || "",
    remarks: editData?.remarks || "",
    entry_no: editData?.entry_no || "",
    dent_in_cylinder: editData?.dent_in_cylinder || "",
    entry_date: editData?.entry_date ? dayjs(editData.entry_date).format("DD/MM/YYYY") : dayjs().format("DD/MM/YYYY"),
    from_plant_id: editData ? editData.from_plant_id || plant_id : plant_id,
    to_plant_id: editData ? editData.to_plant_id || plant_id : plant_id,
    fin_year: editData ? editData.fin_year : (dayjs().month() >= 3 ? `${dayjs().year()}-${dayjs().year() + 1}` : `${dayjs().year() - 1}-${dayjs().year()}`),
    result: editData?.result || "",
  });

  const [cylinder, setCylinder] = useState([]);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [cylinderList, setCylinderList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const qrCodeRegionId = "qr-reader";
  const html5QrcodeRef = useRef(null);
  const scannerStateRef = useRef({ isStarting: false, isStopping: false });
  const lastScanTimeRef = useRef(0);
  const debounceDelay = 500;

useEffect(() => {
    async function fetchData() {
      try {
        const CylinderData = await maintenanceSerivice.getmaintenanccylinderlists(plant_id);
        if (CylinderData && Array.isArray(CylinderData)) {
          setCylinder(CylinderData); setCylinderList(CylinderData);
        } else if (CylinderData?.data && Array.isArray(CylinderData.data)) {
          setCylinder(CylinderData.data); setCylinderList(CylinderData.data);
        }

        // ✅ entry_no generation
        if (!editData) {
          const maintenanceList = await maintenanceSerivice.getmaintenanceList({ page: 0, size: 5, searchKey: "" });
          
          const lastEntryNo = maintenanceList?.[0]?.entry_no ?? "";
          const parts = String(lastEntryNo).split("/");
          const lastSeq = parseInt(parts[parts.length - 1]) || 0;
          const nextSeq = lastSeq + 1;

          const yr = dayjs();
          const finYear = yr.month() >= 3
            ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
            : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;

          const formattedEntryNo = `${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;

          setData(prev => ({
            ...prev,
            entry_no: formattedEntryNo,
            fin_year: finYear,
          }));
        }

      } catch (error) { console.error("Data fetching failed:", error); }
    }
    fetchData();
  }, [plant_id]);

  useEffect(() => {
    if (isScannerOpen && !html5QrcodeRef.current) {
      html5QrcodeRef.current = new Html5Qrcode(qrCodeRegionId);
    }
    if (isScannerOpen) startScanner();
    return () => { if (html5QrcodeRef.current?.isScanning) stopScanner(); };
  }, [isScannerOpen]);

  const startScanner = () => {
    if (scannerStateRef.current.isStarting || html5QrcodeRef.current?.isScanning) return;
    scannerStateRef.current.isStarting = true;
    html5QrcodeRef.current.start(
      { facingMode: "environment" },
      { fps: 10, qrbox: { width: 250, height: 250 } },
      async (decodedText) => {
        const now = Date.now();
        if (now - lastScanTimeRef.current < debounceDelay) return;
        lastScanTimeRef.current = now;
        try {
          const found = cylinder.find(c => c.tag_no === decodedText && !c.is_deleted);
          if (found) {
            setData(prev => ({ ...prev, cylinder_no: found.cylinder_no, cyl_id: found.cyl_id }));
            setSuccessMessage(`Cylinder ${found.cylinder_no} scanned successfully`);
            stopScanner();
          } else setSuccessMessage(`Tag ${decodedText} not found`);
        } catch { setSuccessMessage("Error processing scanned data"); }
      }, () => {}
    ).then(() => { scannerStateRef.current.isStarting = false; })
      .catch(() => { setSuccessMessage("Failed to start QR scanner"); scannerStateRef.current.isStarting = false; setIsScannerOpen(false); });
  };

  const stopScanner = () => {
    if (scannerStateRef.current.isStopping || !html5QrcodeRef.current?.isScanning) {
      setIsScannerOpen(false); return;
    }
    scannerStateRef.current.isStopping = true;
    html5QrcodeRef.current.stop().then(() => {
      html5QrcodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false;
    }).catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
  };

  const handleChange = ({ target: { name, value } }) => {
    setData(prev => {
      let updatedData = { ...prev, [name]: value };
      if (name === "cylinder_no") {
        const sel = cylinder.find(c => c.cylinder_no === value);
        updatedData.cyl_id = sel ? sel.cyl_id : "";
      }
      if (name === "entry_date") {
        const formatted = dayjs(value).isValid() ? dayjs(value).format("DD/MM/YYYY") : "";
        const fin = formatted
          ? (dayjs(formatted, "DD/MM/YYYY").month() >= 3
            ? `${dayjs(formatted, "DD/MM/YYYY").year()}-${dayjs(formatted, "DD/MM/YYYY").year() + 1}`
            : `${dayjs(formatted, "DD/MM/YYYY").year() - 1}-${dayjs(formatted, "DD/MM/YYYY").year()}`)
          : "";
        return { ...updatedData, entry_date: formatted, fin_year: fin };
      }
      return updatedData;
    });
  };

const isSubmittingRef = useRef(false);

  const onSubmit = async () => {
    if (isSubmittingRef.current) return;   // turant block, state ke render ka wait nahi
    if (!data.cylinder_no) return;
    const sel = cylinder.find(c => c.cylinder_no === data.cylinder_no);
    if (!sel || !data.cyl_id) { setSuccessMessage("Please select a valid cylinder."); return; }
    isSubmittingRef.current = true;
    setIsSubmitting(true);

    const toBackendDate = (val) => {
      if (!val) return "";
      if (dayjs(val, "DD/MM/YYYY", true).isValid()) return dayjs(val, "DD/MM/YYYY").format("YYYY-MM-DD");
      if (dayjs(val).isValid()) return dayjs(val).format("YYYY-MM-DD");
      return val;
    };

    const formData = {
      ...data,
      entry_date: toBackendDate(data.entry_date),
      hydro_test_date: toBackendDate(data.hydro_test_date),
      inspection_date: toBackendDate(data.inspection_date),
      cyl_id: Number(data.cyl_id),
      from_plant_id: Number(data.from_plant_id),
      to_plant_id: Number(data.to_plant_id),
      maint_id: editData?.maint_id || null,
      modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      modified_by: userInfo.user_id,
      created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      created_by: editData?.created_by || userInfo.user_id,
      changedUpdatedValue: editData ? "edit" : "add",
      unit_id: Number(unit_id),
      short_code,
    };

   try {
      if (editData) await maintenance.editDeletemaintenance(formData);
      else await maintenance.addmaintenance(formData);
      setSuccessMessage(editData ? "Updated successfully" : "Added successfully");
      setTimeout(() => navigate(-1), 1000);
      // ⚠️ success ke case mein isSubmitting reset NAHI karna — navigate hone tak
      // button disabled hi rehna chahiye, warna dusra click phir se save kar dega
    } catch (error) {
      console.error("Submit error:", error?.response?.data || error.message);
      setSuccessMessage("Error occurred while saving");
      isSubmittingRef.current = false;
      setIsSubmitting(false);   // sirf ERROR case mein reset karo, taaki user retry kar sake
    }
  };
  // Options
  const yesNoOptions = [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }];
  const paintingOptions = [{ label: "Good", value: "Good" }, { label: "Poor", value: "Poor" }];
  const resultOptions = [{ label: "OK", value: "ok" }, { label: "NOT OK", value: "notok" }];

  const acInput = (params, placeholder = "") => (
    <TextField {...params} size="small" fullWidth placeholder={placeholder} sx={inputSx} />
  );

  const renderAutocomplete = (options, fieldName, placeholder = "Select") => (
    <Autocomplete
      options={options}
      fullWidth
      getOptionLabel={o => typeof o === "string" ? o : o.label}
      value={options.find(opt => opt.value === data[fieldName]) || null}
      onChange={(_, nv) => handleChange({ target: { name: fieldName, value: nv ? nv.value : "" } })}
      renderOption={(props, option) => <MenuItem {...props} sx={menuItemSx}>{option.label}</MenuItem>}
      renderInput={(params) => acInput(params, placeholder)}
    />
  );

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        <ReusableSnackbar
          open={!!successMessage}
          onClose={(e, reason) => { if (reason !== "clickaway") setSuccessMessage(""); }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />

        {/* Breadcrumb */}
        <Box sx={{ fontSize: "12px", color: "#718096", mb: 2, display: "flex", alignItems: "center", gap: "6px" }}>
          <span>Dashboard</span> / <span>Entries</span> /{" "}
          <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Maintenance</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <BuildIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} MAINTENANCE ENTRY
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        {/* ══ Card ══ */}
        <Box sx={formCardSx}>
          <Box sx={sectionHeaderSx}>
            <BuildIcon sx={{ fontSize: 18, color: "#fff" }} />
            <Typography sx={sectionHeaderTitleSx}>MAINTENANCE ENTRY DETAILS</Typography>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={formBodySx}>

              {/* ── Two-column bordered grid (same as Production Entry) ── */}
              <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

                {/* LEFT COLUMN — Inspection Checklist */}
                <Grid
                  item xs={12} md={6}
                  sx={{ p: 2.5, borderBottom: { xs: "2px dashed #CBD5E0", md: "none" } ,      }}
                  
                >
                  <Grid container spacing={1.5}>
                    
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Cylinder No <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <Autocomplete
                        options={cylinderList}
                        fullWidth
                        getOptionLabel={o => typeof o === "string" ? o : (o.cylinder_no || "")}
                        value={cylinderList.find(c => c.cylinder_no === data.cylinder_no) || null}
                        onChange={(_, nv) => handleChange({ target: { name: "cylinder_no", value: nv ? nv.cylinder_no : "" } })}
                        renderOption={(props, option) => (
                          <MenuItem {...props} sx={menuItemSx}>{option.cylinder_no}</MenuItem>
                        )}
                        renderInput={(params) => acInput(params, "Select cylinder")}
                      />
                    </Grid>

                     <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Hydro Test Due <span style={{ color: "#E53E3E" }}>*</span></Typography>
                      <DatePicker
                        format="DD/MM/YYYY"
                        value={dayjs(data.hydro_test_date, "DD/MM/YYYY")}
                        onChange={nv => handleChange({ target: { name: "hydro_test_date", value: nv ? nv.toDate() : "" } })}
                        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: datePickerSx } }}
                      />
                    </Grid>
<Grid item xs={12}>
  <Divider sx={{ borderColor: "#E2E8F0", borderWidth: "1px", my: 1 }} />
</Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Leakage From Valve</Typography>
                      {renderAutocomplete(yesNoOptions, "leakage_from_valve")}
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Leakage From Neck Thread</Typography>
                      {renderAutocomplete(yesNoOptions, "leakage_from_cyl_neck_thread")}
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Leakage From Fusible Plug</Typography>
                      {renderAutocomplete(yesNoOptions, "leakage_from_fusible_plug")}
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Corrosion Bottom Ring</Typography>
                      {renderAutocomplete(yesNoOptions, "corrosion_bottom_ring")}
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Dent in Cylinder</Typography>
                      {renderAutocomplete(yesNoOptions, "dent_in_cylinder")}
                    </Grid>

                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Burn Mark</Typography>
                      {renderAutocomplete(yesNoOptions, "burn_mark")}
                    </Grid>

                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Damaged / Bent Valve</Typography>
                      {renderAutocomplete(yesNoOptions, "damaged_valve")}
                    </Grid> */}

                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Painting</Typography>
                      {renderAutocomplete(paintingOptions, "painting")}
                    </Grid> */}

                    {/* <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Tag Not Readable</Typography>
                      {renderAutocomplete(yesNoOptions, "tag_not_readable")}
                    </Grid> */}
{/* 
                    <Grid item xs={7} sm={5}>
                      <Typography sx={fieldLabelSx}>Corrosion or Pitting</Typography>
                      {renderAutocomplete(yesNoOptions, "corrosion_pitting")}
                    </Grid> */}

                    <Grid item xs={12}>
                      <Typography sx={fieldLabelSx}>Remarks</Typography>
                      <TextField
                        size="small" fullWidth multiline rows={2}
                        name="remarks" value={data.remarks} onChange={handleChange}
                        placeholder="Enter remarks"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "8px", fontSize: "13px",
                            fontFamily: "'Inter', Arial, sans-serif",
                            background: "#fafafa",
                            "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
                            "&:hover fieldset": { borderColor: "#CBD5E0" },
                            "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
                          },
                          "& textarea": { fontSize: "13px", color: "#1A202C", fontFamily: "'Inter', Arial, sans-serif" },
                        }}
                      />
                    </Grid>

                  </Grid>
                </Grid>

                {/* RIGHT COLUMN — Entry Information */}
                {/* RIGHT COLUMN */}
<Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC" }}>
  <Grid container spacing={1.5}>

    <Grid item xs={12} sm={6}>  {/* ← xs={12} sm={6} */}
      <Typography sx={fieldLabelSx}>Entry No</Typography>
      <TextField
        size="small" fullWidth
        value={data.entry_no}
        InputProps={{ readOnly: true }}
        sx={readonlyInputSx}
        placeholder="Auto-generated"
      />
    </Grid>

    <Grid item xs={12} sm={6}>  {/* ← xs={12} sm={6} */}
      <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
      <DatePicker
        format="DD/MM/YYYY"
        value={dayjs(data.entry_date, "DD/MM/YYYY")}
        onChange={nv => handleChange({ target: { name: "entry_date", value: nv ? nv.toDate() : "" } })}
        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: datePickerSx } }}
      />
    </Grid>

    {/* ✅ Divider */}
    <Grid item xs={12}>
      <Divider sx={{ borderColor: "#E2E8F0", borderWidth: "1px", my: 1 }} />
    </Grid>

    <Grid item xs={12} sm={6}>
      <Typography sx={fieldLabelSx}>Damaged / Bent Valve</Typography>
      {renderAutocomplete(yesNoOptions, "damaged_valve")}
    </Grid>

    <Grid item xs={12} sm={6}>
      <Typography sx={fieldLabelSx}>Painting</Typography>
      {renderAutocomplete(paintingOptions, "painting")}
    </Grid>

    <Grid item xs={12} sm={6}>
      <Typography sx={fieldLabelSx}>Tag Not Readable</Typography>
      {renderAutocomplete(yesNoOptions, "tag_not_readable")}
    </Grid>

    <Grid item xs={12} sm={6}>
      <Typography sx={fieldLabelSx}>Corrosion or Pitting</Typography>
      {renderAutocomplete(yesNoOptions, "corrosion_pitting")}
    </Grid>

    <Grid item xs={12} sm={6}>
      <Typography sx={fieldLabelSx}>Inspection Due <span style={{ color: "#E53E3E" }}>*</span></Typography>
      <DatePicker
        format="DD/MM/YYYY"
        value={dayjs(data.inspection_date, "DD/MM/YYYY")}
        onChange={nv => handleChange({ target: { name: "inspection_date", value: nv ? nv.toDate() : "" } })}
        slotProps={{ textField: { size: "small", fullWidth: true, required: true, sx: datePickerSx } }}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <Typography sx={fieldLabelSx}>Result</Typography>
      {renderAutocomplete(resultOptions, "result", "Select result")}
    </Grid>

  </Grid>
</Grid>

              </Grid>
            </Box>

            {/* Footer */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
              <Button type="submit" disabled={isSubmitting} sx={saveBtnSx}>
                <SaveIcon sx={{ fontSize: 17 }} />
                {editData ? "Update" : "Save"}
              </Button>
            </Box>
          </form>
        </Box>

      </Box>
    </LocalizationProvider>
  );
};

export default Addmaintenance;